export const USER_CARD_MESSAGES = {
    DEFAULT_CAR_IMAGE: '/images/seo/CarImage.png',
    CAR_IMAGE_ALT: 'Car-Image',
    UPCOMING_BOOKING_TITLE: 'Upcoming booking',
    RESUME_BOOKING_TITLE: 'Complete your booking',
};
